// extracted by mini-css-extract-plugin
module.exports = {"Infobox":"_3H6NzE","customIcon":"_3Z_Qm3","text":"_259v56"};